const LinkedInLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.75 0.75H3.25C1.86875 0.75 0.75 1.86875 0.75 3.25V20.75C0.75 22.1313 1.86875 23.25 3.25 23.25H20.75C22.1313 23.25 23.25 22.1313 23.25 20.75V3.25C23.25 1.86875 22.1313 0.75 20.75 0.75ZM8.25 18.25H5.09625V9.5H8.25V18.25ZM6.6175 7.89625C5.65375 7.89625 5.01 7.25375 5.01 6.39625C5.01 5.53875 5.6525 4.89625 6.72375 4.89625C7.6875 4.89625 8.33125 5.53875 8.33125 6.39625C8.33125 7.25375 7.68875 7.89625 6.6175 7.89625ZM19.5 18.25H16.4475V13.4675C16.4475 12.145 15.6337 11.84 15.3288 11.84C15.0238 11.84 14.0062 12.0437 14.0062 13.4675C14.0062 13.6712 14.0062 18.25 14.0062 18.25H10.8525V9.5H14.0062V10.7213C14.4125 10.0087 15.2262 9.5 16.7525 9.5C18.2787 9.5 19.5 10.7212 19.5 13.4675V18.25Z"
                fill="#222222"
            />
        </svg>
    )
}

export default LinkedInLogo